import { render, staticRenderFns } from "./LinkedInButton.vue?vue&type=template&id=407ee3a4&scoped=true"
import script from "./LinkedInButton.vue?vue&type=script&lang=js"
export * from "./LinkedInButton.vue?vue&type=script&lang=js"
import style0 from "./LinkedInButton.vue?vue&type=style&index=0&id=407ee3a4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "407ee3a4",
  null
  
)

export default component.exports